import React from "react";
import { useTranslation } from "react-i18next";
import { PinInput } from "./PinInput";
import { LinkButton } from "./LinkButton";
import { ForgetEmailLink } from "./SavedAccountLinks";
import { LinkRow, Screen, ScreenBody, ScreenTitle } from "./Screen";

export interface PinLoginProps {
  email: string;
  value: string;
  onChange(value: string): void;
  error?: string;
  disabled?: boolean;
  pending?: boolean;
  online: boolean;
  onPassword(): void;
  onChangePin(): void;
  onForget(): void;
}

export const PinLogin: React.FC<PinLoginProps> = ({
  email,
  value,
  onChange,
  error,
  disabled,
  pending,
  online,
  onPassword,
  onChangePin,
  onForget,
}) => {
  const { t } = useTranslation();

  return (
    <Screen testId="login-pin" offline={!online}>
      <ScreenTitle>{t("Enter your PIN")}</ScreenTitle>
      <ScreenBody>{`${t("Signing in as")} ${email}`}</ScreenBody>
      <PinInput
        value={value}
        onChange={onChange}
        error={error}
        disabled={disabled}
      />
      <LinkRow>
        <div className="flex flex-col items-start gap-2">
          <LinkButton onClick={onPassword} disabled={!online || pending}>
            {t("Log in with password")}
          </LinkButton>
          <LinkButton onClick={onChangePin} disabled={!online || pending}>
            {t("Change PIN")}
          </LinkButton>
        </div>
        <ForgetEmailLink email={email} onForget={onForget} />
      </LinkRow>
    </Screen>
  );
};
